import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { RegistrationserviceService } from '../services/registrationservice.service';
import { Registration } from '../Models/registration';
import { Router } from '@angular/router';
import { debug } from 'util';

declare function responsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function registrationvoiceOnKeyPress(value, key, eventId): any;
declare function voiceOnAPIHit(Message): any;
declare function voiceForUserExists(flag): any;
declare const responsiveVoiceSignupPageLoad: any;
declare function AcceptNotAccept(eventId): any;
declare function CheckforSession(targetid): any;
declare function NewAndExistsUserFlag(flag): any;
var IsOtherKeyClickedWhenSubmit = 0;

var dataLength = 0;
declare var $: any;

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})

export class RegistrationComponent implements OnInit {
  registrationForm: FormGroup;
  datasaved = false;
  message: string;

  constructor(private formbuilder: FormBuilder, private router: Router, private registrationservice: RegistrationserviceService) { }
  onKeyUp(event: any) {
    if ((event.target.id == "Radioaccept" || event.target.id == "donotRadio") && (event.ctrlKey == true)) {
      event.preventDefault();
      return;
    }
    if (event.target.id == "emaillabel" && event.keyCode == 13) {
      return;
    }
    debugger;
    if (event.target.id == "submitbtnregistration" && event.keyCode == 13) {
      return;
    }

    if (event.target.id == "Email" && event.keyCode == 8 && dataLength == 1) {
      var inputfirstName = <HTMLInputElement>document.getElementById("first_name");
      inputfirstName.value = "";
      var inputlastName = <HTMLInputElement>document.getElementById("last_name");
      inputlastName.value = "";
      var inputTelephone = <HTMLInputElement>document.getElementById("phone_number");
      inputTelephone.value = "";
      var inputExtension = <HTMLInputElement>document.getElementById("Extension_name");
      inputExtension.value = "";
      return;
    }

    if (event.target.id == "submitbtnregistration" && event.keyCode == 32) {
      IsOtherKeyClickedWhenSubmit = 1;
    }
    var element = document.getElementById("emaillabel");
    element.classList.add("divfocushover");
    if (event.keyCode == 9 || event.keyCode == 13 || event.keyCode == 32 || event.keyCode == 8) {
      if (event.ctrlKey == false) {
        responsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
    }
  };
  onkeypress(event: any) {
    debugger;

    // check for user can input characters only.
    if (event.target.id == "first_name" || event.target.id == "last_name") {
      const pattern = /^[a-zA-Z]+$/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
        return;
      }
    }

    // check for user can input numeric digit only.
    if (event.target.id == "phone_number" || event.target.id == "Extension_name") {
      const pattern = /[0-9\+\-\ ]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
        return;
      }
    }

    // Check for phone number length
    if (event.target.id == "phone_number") {
      var input = <HTMLInputElement>document.getElementById("phone_number");
      var phonenumber = event.target.value + event.key
      if (phonenumber.includes("-")) {
        input.maxLength = 12;
      }
      else {
        input.maxLength = 10;
      }
    }

    // check for user can input email format only.
    if (event.target.id == "Email") {

      // Restrict for multiple @ Key
      if (event.charCode == 64) {
        var look = "@";
        var EmailValue = event.target.value;
        var haslook = new RegExp(look).test(EmailValue);
        if (haslook == true) {
          event.preventDefault();
          return;
        }
      }

      if (event.charCode == 45) {
        // allow - Key
      }
      else {
        const pattern = /[A-Z0-9a-z@\._]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
          event.preventDefault();
          return;
        }
      }


    }

    registrationvoiceOnKeyPress(event.target.value, event.key, event.target.id);

    // API for check user already exists or not.
    if (event.target.id == "Email") {
      debugger;
      const EmailPattern = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      var emailId = event.target.value + event.key
      if (EmailPattern.test(emailId)) {
        this.loadRegistrationDetails(emailId);
      }
    }
  }
  AcceptNotAcceptclick(event: any) {
    debugger;
    if (event.ctrlKey == true) {
      event.preventDefault();
      return;
    }
    AcceptNotAccept(event.target.id);
  }
  ngOnInit() {
    debugger;
    var EmailValidationClass = document.getElementById("Email");
    EmailValidationClass.classList.remove("loginvalidation");

    var PhoneNumberValidationClass = document.getElementById("phone_number");
    PhoneNumberValidationClass.classList.remove("loginvalidation");

    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }

    //============Voice Annotation On/Off=========
    if ($('#hidVoiceOnOff').val() == "OFF") {
      $('#btnVoiceAnnotation').val('OFF');
      $('#hidVoiceOnOff').val('OFF');
      $('#btnPlayPause').css('display', 'none');
    }
    else {
      $('#btnVoiceAnnotation').val('ON');
      $('#hidVoiceOnOff').val('ON');
      $('#btnPlayPause').css('display', 'block');
    }

    responsiveVoiceSignupPageLoad();

    this.setFormState();
    this.checksessionStorage();

  }
  setFormState(): void {
    debugger;
    this.registrationForm = this.formbuilder.group({
      EmailId: ['', [Validators.required]],
      FirstName: ['', [Validators.required]],
      LastName: ['', [Validators.required]],
      Telephone: ['', [Validators.required]],
      Extension: ['', []],
      CheckBox: ['', [Validators.required]]
    })
  }
  // checking exact session data with key name 
  checksessionStorage() {
    debugger;
    if (!sessionStorage['sessionData']) {

      if (document.getElementById("loginAction") != null || document.getElementById("loginAction") != undefined) {
        document.getElementById("loginAction").style.display = "block";
      }
      if (document.getElementById("btnComboLogin") != null || document.getElementById("btnComboLogin") != undefined) {
        document.getElementById("btnComboLogin").style.display = "block";
      }

      document.getElementById("LogoutPage").style.display = "none";
      document.getElementById("BrowseObligorPage").style.display = "none";
      document.getElementById("divGotoBrowseObligor").style.display = "none";
    }
    if (sessionStorage['sessionData']) {
      if (document.getElementById("loginAction") != null || document.getElementById("loginAction") != undefined) {
        document.getElementById("loginAction").style.display = "none";
      }
      if (document.getElementById("btnComboLogin") != null || document.getElementById("btnComboLogin") != undefined) {
        document.getElementById("btnComboLogin").style.display = "none";
      }

      document.getElementById("LogoutPage").style.display = "block";
      document.getElementById("BrowseObligorPage").style.display = "block";
      document.getElementById("divGotoBrowseObligor").style.display = "block";
    }
  }
  onSubmit() {
    debugger;
    if (IsOtherKeyClickedWhenSubmit == 1) {
      IsOtherKeyClickedWhenSubmit = 0;
      return;
    }
    // Check valid emailid before submit button.
    var EmailIDInput = <HTMLInputElement>document.getElementById("Email");
    if (EmailIDInput.value != "") {
      debugger;
      const EmailPattern = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!EmailPattern.test(EmailIDInput.value)) {
        responsiveVoiceSpeak("", "", 13, "", "lblfirstName", "", "", "", "", "");
        var EmailValidationClass = document.getElementById("Email");
        EmailValidationClass.classList.add("loginvalidation");
        return;
      }
    }
    var RemoveEmailValidationClass = document.getElementById("Email");
    RemoveEmailValidationClass.classList.remove("loginvalidation");

    // Check valid Telephone before submit button.
    var PhoneNumberInput = <HTMLInputElement>document.getElementById("phone_number");
    if (PhoneNumberInput.value.length < 12) {
      responsiveVoiceSpeak("", "", 13, "", "lblExtension", "", "", "", "", "");
      var PhoneNumberValidationClass = document.getElementById("phone_number");
      PhoneNumberValidationClass.classList.add("loginvalidation");
      return;
    }

    var RemovePhoneNumberValidationClass = document.getElementById("phone_number");
    RemovePhoneNumberValidationClass.classList.remove("loginvalidation");

    var donotAccept = <HTMLInputElement>document.getElementById("donotRadio");
    if (donotAccept.checked == true) {
      // If an existing user select I don’t agree to the user agreement then user will be log out and go to the home page.
      this.registrationservice.LogoutInvestorAccount().subscribe(data => {
      });
      CheckforSession("LogoutPageHit");
      this.checksessionStorage();
      //this.router.navigate(['/Dachomepage']);
      return;
    }

    let registration = this.registrationForm.value;
    this.createRegistration(registration);
    this.registrationForm.reset();
    var input = <HTMLInputElement>document.getElementById("Extension_name");
    input.value = "";
  }
  createRegistration(registration: Registration) {
    debugger;
    var inputEmail = registration.EmailId;
    this.registrationservice.LoginAndRegisterInvestorAccount(registration).subscribe(
      () => {
        this.datasaved = true;
        if (dataLength == 0) {
          this.message = "You have registered successfully.";
          voiceOnAPIHit(this.message);
        }
        if (dataLength == 1) {
          this.message = "Your information is updated successfully.";
          voiceOnAPIHit(this.message);
        }

        //Create session Bag when user is register.          
        this.GetRegistrationUser(inputEmail);
        this.registrationForm.reset();
      }
    )
  }
  loadRegistrationDetails(emailId: string) {
    debugger;
    dataLength = 0;
    this.registrationservice.getRegisterUserByEmailID(emailId).subscribe(data => {
      debugger;
      if (data["adaInvestorMatchFound"] == true) {
        dataLength = 1;
      }

      if (data["adaInvestorMatchFound"] == true) {
        this.registrationForm.controls['FirstName'].setValue(data["userRecord"].firstName);
        this.registrationForm.controls['LastName'].setValue(data["userRecord"].lastName);
        this.registrationForm.controls['Telephone'].setValue(data["userRecord"].phoneNumber);
        if (data["userRecord"].phoneNumberExt == null || data["userRecord"].phoneNumberExt == "") {
          var input = <HTMLInputElement>document.getElementById("Extension_name");
          input.value = "";
        }
        else {
          this.registrationForm.controls['Extension'].setValue(data["userRecord"].phoneNumberExt);
        }
        //Disable Email input when user exits.
        NewAndExistsUserFlag(1);
        voiceForUserExists(dataLength);
        //var EmailInput = <HTMLInputElement>document.getElementById("Email");//.disabled = false;
        //EmailInput.disabled = true;
        //Create session Bag when user already exists.
        //sessionStorage.setItem('sessionData', JSON.stringify(data["userRecord"]));
        //this.checksessionStorage();

        // Set focus on firstName when user exists.
        var element = document.getElementById("emaillabel");
        element.classList.remove("divfocushover");
        $('#emaillabel').focus();
      }
      else {
        NewAndExistsUserFlag(0);
      }
    });
  }
  GetRegistrationUser(emailId: string) {
    debugger;
    this.registrationservice.getRegisterUserByEmailID(emailId).subscribe(data => {
      debugger;
      //if (data["adaInvestorMatchFound"] == true) {
      //  dataLength = 1;
      //}
      if (data["adaInvestorMatchFound"] == true) {
        //Create session Bag when user already exists.
        sessionStorage.setItem('sessionData', JSON.stringify(data["userRecord"]));
        this.checksessionStorage();
      }
    });
  }
}
